import { Card } from "antd";
import React from "react";

const GuestUsers = () => {
  return <Card>Guest Users</Card>;
};

export default GuestUsers;

